/* generated using openapi-typescript-codegen — list/mutate methods hand-extended */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {
    AdEntityBatchUpdateRequest,
    AdEntityBatchUpdateResponse,
    AdEntityListResponse,
} from '../models/AdEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GoogleAdsService {
    /**
     * Connect a Google Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Google Ads account
     * @throws ApiError
     */
    public static postGoogleAdsConnect(
        workspaceId: string,
        requestBody: {
            name: string;
            client_id?: string;
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/google_ads/connect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Google Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully disconnected a Google Ads account
     * @throws ApiError
     */
    public static postGoogleAdsDisconnect(
        workspaceId: string,
        requestBody: {
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/google_ads/disconnect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Save a Google token
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully saved Google user token
     * @throws ApiError
     */
    public static postGoogleAdsToken(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/google_ads/token',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List available to connect Google Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List available to connect Google Ads accounts
     * @throws ApiError
     */
    public static getGoogleAdsAvailable(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/available',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List clients to connect Google Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @param adAccountId Ad account id
     * @param nextToken Next token (optional)
     * @returns any List clients to connect Google Ads accounts
     * @throws ApiError
     */
    public static getGoogleAdsClients(
        workspaceId: string,
        adAccountId: string,
        nextToken?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/clients',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
                'next_token': nextToken,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Google Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Google Ads accounts
     * @throws ApiError
     */
    public static getGoogleAdsConnected(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/connected',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Google Ads campaigns
     */
    public static getGoogleAdsCampaigns(
        workspaceId: string,
        adAccountId: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/campaigns',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Google Ads ad groups
     */
    public static getGoogleAdsAdGroups(
        workspaceId: string,
        adAccountId: string,
        campaignId?: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/ad_groups',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
                'campaign_id': campaignId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Google Ads ads
     */
    public static getGoogleAdsAds(
        workspaceId: string,
        adAccountId: string,
        adGroupId?: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/google_ads/ads',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
                'ad_group_id': adGroupId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Batch update Google Ads entities (status / daily_budget)
     */
    public static postGoogleAdsEntitiesBatchUpdate(
        workspaceId: string,
        requestBody: AdEntityBatchUpdateRequest,
    ): CancelablePromise<AdEntityBatchUpdateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/google_ads/entities/batch_update',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
}
